import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {replaceSpaceWithNonBreakingSpace} from "@pg-mono/string-utils";

import {HorizontalArticleList} from "../../../article/components/HorizontalArticleList";
import {IVendorDetailArticle} from "../../actions/fetch_vendor_detail_related_articles";
import {VendorContainer} from "../VendorContainer";

interface IProps {
    vendorName: string;
    articles: IVendorDetailArticle[];
}

export const VendorDetailArticles = (props: IProps) => {
    return (
        <div className={articlesHolderStyle}>
            <VendorContainer>
                <Text as="h2" variant="headline_4" className={headingStyle}>
                    Wiadomości na temat {replaceSpaceWithNonBreakingSpace(props.vendorName)}
                </Text>

                <HorizontalArticleList articles={props.articles} />
            </VendorContainer>
        </div>
    );
};

const articlesHolderStyle = css({
    backgroundColor: "var(--colors-background-200)",
    paddingTop: 5,
    paddingBottom: 5
});

const headingStyle = css({
    color: "var(--colors-gray-800)",
    textAlign: "center",
    marginBottom: 4,
    md: {
        textAlign: "left"
    }
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {replaceSpaceWithNonBreakingSpace} from "@pg-mono/string-utils";

import {HorizontalArticleList} from "../../../article/components/HorizontalArticleList";
import {IVendorDetailArticle} from "../../actions/fetch_vendor_detail_related_articles";
import {VendorContainer} from "../VendorContainer";

interface IProps {
    vendorName: string;
    articles: IVendorDetailArticle[];
}

export const VendorDetailArticles = (props: IProps) => {
    return (
        <div className={articlesHolderStyle}>
            <VendorContainer>
                <Text as="h2" variant="headline_4" className={headingStyle}>
                    Wiadomości na temat {replaceSpaceWithNonBreakingSpace(props.vendorName)}
                </Text>

                <HorizontalArticleList articles={props.articles} />
            </VendorContainer>
        </div>
    );
};

const articlesHolderStyle = css({
    backgroundColor: "var(--colors-background-200)",
    paddingTop: 5,
    paddingBottom: 5
});

const headingStyle = css({
    color: "var(--colors-gray-800)",
    textAlign: "center",
    marginBottom: 4,
    md: {
        textAlign: "left"
    }
});
